module.exports = __webpack_public_path__ + "img/20190531170815636.8a0d05b4.png";